import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 35"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<ellipse cx=\"2.25\" cy=\"2.125\" fill=\"#d9d9d9\" rx=\"2.25\" ry=\"2.125\"></ellipse><ellipse cx=\"8.75\" cy=\"2.125\" fill=\"#d9d9d9\" rx=\"2.25\" ry=\"2.125\"></ellipse><ellipse cx=\"2.25\" cy=\"11.375\" fill=\"#d9d9d9\" rx=\"2.25\" ry=\"2.125\"></ellipse><ellipse cx=\"8.75\" cy=\"11.375\" fill=\"#d9d9d9\" rx=\"2.25\" ry=\"2.125\"></ellipse><ellipse cx=\"2.25\" cy=\"20.625\" fill=\"#d9d9d9\" rx=\"2.25\" ry=\"2.125\"></ellipse><ellipse cx=\"8.75\" cy=\"20.625\" fill=\"#d9d9d9\" rx=\"2.25\" ry=\"2.125\"></ellipse><ellipse cx=\"2.25\" cy=\"29.875\" fill=\"#d9d9d9\" rx=\"2.25\" ry=\"2.125\"></ellipse><ellipse cx=\"8.75\" cy=\"29.875\" fill=\"#d9d9d9\" rx=\"2.25\" ry=\"2.125\"></ellipse>", 8)
  ]))]))
}
export default { render: render }